<template>
  <div class="verify-token-mail row justify-content-center mt-5 mb-5 pt-5 pb-5">
    <template v-if="errMsg">
      <div class="col-12 text-center"><i class="icon bi bi-exclamation-circle text-danger"></i></div>
      <div class="col-12 text-center">{{ errMsg }}</div>
    </template>
    <template v-else-if="verifyToken && email">
      <div class="col-12 text-center"><i class="icon bi bi-hourglass"></i></div>
      <div class="col-12 text-center">驗證中，請稍候...</div>
    </template>
    <template v-else>
      <div class="col-12 text-center"><img class="icon mb-3" src="@/assets/img/ic-email-ok.svg" alt=""></div>
      <div class="col-12 text-center">會員驗證信已寄出，請查看您的E-mail信箱。</div>
    </template>
    <div class="col-12 text-center">如須協助，請聯繫客服。</div>
  </div>
</template>

<script>
import authApi from '@/api/auth.js'
import constant from '@/constant.js'
import { mapMutations } from 'vuex'

export default {
  name: 'VerifyTokenMail',
  data: function () {
    return {
      errMsg: null
    }
  },
  computed: {
    verifyToken: function () {
      return this.$route.query.verifyToken
    },
    email: function () {
      return this.$route.query.email
    }
  },
  mounted: function () {
    if (this.verifyToken && this.email) {
      this.apiAuthAccount()
    }
  },
  methods: {
    ...mapMutations([
      'setAlert'
    ]),
    apiAuthAccount: function () {
      var self = this
      authApi.authAccount(this.email, this.verifyToken, function (err, rspData) {
        if (err) {
          // self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `驗證錯誤(${err})` })
          self.errMsg = `驗證錯誤(${err})`
          return
        }
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '驗證完成，請重新登入' })
        self.$router.replace('/w/sign-in')
      })
    }
  }
}
</script>

<style scoped>
.icon {
  font-size: 5rem;
  color: gray;
}
img.icon {
  width: 96px;
  height: 96px;
}
</style>
